var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("header-view", {
                staticClass: "text-uppercase",
                attrs: { title: _vm.$t("message.imprint.title"), icon: "" }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _c("b-col", [
            _c("address", [_vm._v("CodeCamp:N GmbH")]),
            _vm._v(" "),
            _c("address", [_vm._v("Solgerstr. 18")]),
            _vm._v(" "),
            _c("address", [_vm._v("90429 Nürnberg")]),
            _vm._v(" "),
            _c("p", [_vm._v(" ")]),
            _vm._v(" "),
            _c("p", [_vm._v("info [at] codecamp-n.com")]),
            _vm._v(" "),
            _c("p", [_vm._v("Tel.: +49 (0)911 / 27 44 85 23")]),
            _vm._v(" "),
            _c("p", [_vm._v(" ")]),
            _vm._v(" "),
            _c("p", [_vm._v("Geschäftsführer:")]),
            _vm._v(" "),
            _c("p", [_vm._v("Florian Zenk")]),
            _vm._v(" "),
            _c("p", [_vm._v("Bernhard Preuschoff")]),
            _vm._v(" "),
            _c("p", [_vm._v("Gerlinde Wanke")]),
            _vm._v(" "),
            _c("p", [_vm._v(" ")]),
            _vm._v(" "),
            _c("p", [_vm._v("Registernummer: HRB 34360")]),
            _vm._v(" "),
            _c("p", [_vm._v("Registergericht: Amtsgericht Nürnberg")]),
            _vm._v(" "),
            _c("p", [_vm._v(" ")]),
            _vm._v(" "),
            _c("p", [_vm._v("Umsatzsteuer-ID: DE133500778")]),
            _vm._v(" "),
            _c("p", [_vm._v(" ")]),
            _vm._v(" "),
            _c("h4", { staticClass: "text-uppercase" }, [
              _vm._v("RECHTLICHE HINWEISE")
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(" ")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Die Inhalte auf dieser Internetseite, der Hauptseite sowie allen\n        Unterseiten werden sorgfältig erarbeitet und laufend gepflegt. Die\n        CodeCamp:N GmbH ist dabei bemüht gemäß § 7 Abs. 1 Telemediengesetz\n        (TMG) diese Inhalte vollständig und aktuell zu halten.\n        Nichtsdestotrotz können fehlerhafte Inhalte enthalten sein, weshalb\n        die CodeCamp:N GmbH keine Gewähr nach §§ 8 bis 10 TMG für\n        Vollständigkeit, Aktualität und Richtigkeit der Inhalte übernimmt. Die\n        Inhalte sollen nur der allgemeinen Information dienen und sind\n        deswegen bewusst allgemein formuliert und stellen keine Beratung des\n        Nutzers für den Einzelfall dar und können keine Einzelfallberatung\n        ersetzen. Die CodeCamp:N GmbH haftet nicht für Schäden, die daraus\n        resultieren, dass auf die Vollständigkeit, Aktualität und Richtigkeit\n        der Inhalte dieser Internetseite vertraut wurde. Es sei denn der\n        Schaden resultiert aus vorsätzlicher oder grob fahrlässiger\n        Falschinformation. Diesbezüglich ist eine Haftung jedoch erst ab dem\n        Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei\n        Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese\n        Inhalte umgehend entfernen. Die CodeCamp:N GmbH behält sich das Recht\n        vor, jederzeit Änderungen, Ergänzungen oder Löschungen der Inhalte\n        dieser Internetseite vorzunehmen.\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(" ")]),
            _vm._v(" "),
            _c("h4", { staticClass: "text-uppercase" }, [
              _vm._v("URHEBERRECHTE / MARKEN UND LOGOS")
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(" ")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Die Inhalte und Werke auf dieser Internetseite, der Hauptseite sowie\n        allen Unterseiten sind nach deutschem Urheberrecht geschützt. Ohne\n        vorherige schriftliche Zustimmung der CodeCamp:N GmbH dürfen Inhalte,\n        insbesondere Texte, Bilder, Grafiken etc., nicht genutzt oder\n        verwendet werden. Dies gilt für jegliche Nutzungen, also ganz oder\n        teilweise, privat oder kommerziell. Die Marken und Logos auf der\n        Internetseite der CodeCamp:N GmbH sind urheberrechtlich geschützt.\n        Ohne vorherige schriftliche Zustimmung der CodeCamp:N GmbH dürfen\n        Marken oder Logos nicht genutzt werden. Dies gilt für jegliche\n        Nutzungen, also ganz oder teilweise, privat oder kommerziell.\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(" ")]),
            _vm._v(" "),
            _c("h4", { staticClass: "text-uppercase" }, [
              _vm._v(
                "\n        HYPERLINKS UND VERWEISE AUF INTERNETSEITEN DRITTER\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(" ")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Wenn Sie Internetseiten Dritter aufrufen, verlassen Sie insoweit die\n        Internetseite der CodeCamp:N GmbH. Die CodeCamp:N GmbH ist für den\n        Inhalt von Internetseiten Dritter nicht verantwortlich. Die CodeCamp:N\n        GmbH haftet nicht für den Inhalt von Internetseiten Dritter. Die\n        CodeCamp:N GmbH übernimmt keine weitere Haftung für die\n        Vollständigkeit, Aktualität oder Richtigkeit von Internetseiten\n        Dritter, soweit hierauf mit einem Hyperlink oder sonstigem Verweis\n        referenziert wird. Die CodeCamp:N GmbH macht sich die Inhalte der\n        Internetseite Dritter nicht zu Eigen.\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(" ")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Bei der erstmaligen Verknüpfung haben wir den fremden Inhalt\n        genauestens überprüft. Jedoch trifft uns keine Verpflichtung zur\n        laufenden Überprüfung auf Veränderung der Inhalte, auf die wir\n        verweisen. Stellen wir jedoch fest, dass ein Inhalt einer fremden\n        Seite, die wir verknüpft haben, eine zivil- oder strafrechtliche\n        Verantwortlichkeit auslöst, werden wir den Link auf diese Seite\n        aufheben, soweit uns dies möglich und zumutbar ist.\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(" ")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Gerne nehmen wir Hinweise an, dass ein solcher Fall vorliegen könnte.\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(" ")]),
            _vm._v(" "),
            _c("p", [_vm._v("Ihre CodeCamp:N GmbH")])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e99998d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e99998d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/Imprint.vue
// module id = TuzM
// module chunks = 1